import { _js } from '@ifixit/localize';
import { faUndo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const UndoButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().undo().run()}
         isDisabled={!editor.can().undo()}
         icon={<FontAwesomeIcon icon={faUndo} />}
         title={_js('Undo')}
         shortcut={'z'}
      />
   );
};
